import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

/* ── Constants ──────────────────────────────────────────── */

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Team", href: "/team" },
  { title: "Reports", href: "/team/reports" },
]

const reportLinks = [
  {
    label: "All Activity",
    href: "/team/activity",
    description: "View all time entries, expenses, and mileage",
  },
  {
    label: "Time",
    href: "/team/activity?type=T",
    description: "Time entries and hours worked",
  },
  {
    label: "Expenses",
    href: "/team/activity?type=E",
    description: "Expense reports and reimbursements",
  },
  {
    label: "Mileage",
    href: "/team/activity?type=M",
    description: "Mileage logs and travel",
  },
  {
    label: "Payments",
    href: "/team/payments",
    description: "Payment history and records",
  },
  {
    label: "Payroll",
    href: "/team/payroll",
    description: "Payroll reports and summaries",
  },
]

/* ── Component ──────────────────────────────────────────── */

export default function Reports() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Team - Reports" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Reports</h1>

        <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {reportLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="border-hpi-light-gray hover:border-hpi-blue hover:bg-hpi-light-gray/30 block rounded border bg-white px-5 py-4 transition-colors"
              >
                <span className="text-hpi-blue text-base font-medium">
                  {link.label}
                </span>
                <p className="text-hpi-med-gray mt-1 text-sm">
                  {link.description}
                </p>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </AppLayout>
  )
}
